import React from "react";
import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";
import { safeAreaAbsoluteTop } from "../../../styles/safeArea";
import closeIcon from "../../../assets/images/icons/cross.svg";
import backIcon from "../../../assets/images/icons/arrow-left-straight.svg";

interface OffCanvasTrayCloseProps {
  showBackIcon?: boolean;
  onClick?: () => void;
}

/* On mobile (smDown) the close sits at top: 50% of OffCanvasTrayHeader,
 * which folds the safe-area inset into its own padding-top — so the
 * button shifts down with the bump and no separate fix is needed.
 * On desktop (smUp) it's absolutely placed at top: 40px relative to
 * the tray; safeAreaAbsoluteTop bumps that by env() on standalone. */
const StyledOffCanvasTrayClose = styled.button<OffCanvasTrayCloseProps>`
  display: inline-block;
  width: 25px;
  height: 16px;
  background: url("${(props) => (props.showBackIcon ? backIcon : closeIcon)}") no-repeat 50% 50% / contain;
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  ${breakpoints.smUp} {
    width: 30px;
    height: 30px;
    background: url("${(props) => (props.showBackIcon ? backIcon : closeIcon)}") no-repeat 50% 50% / 20px;
    left: 25px;
    transform: none;
    ${safeAreaAbsoluteTop(40)}
  }
`;

const OffCanvasTrayClose = ({ showBackIcon = false, onClick }: OffCanvasTrayCloseProps) => (
  <StyledOffCanvasTrayClose showBackIcon={showBackIcon} onClick={onClick} />
);

export default OffCanvasTrayClose;
